'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
var react = require('@emotion/react');
var styledSystem = require('styled-system');
var styled = require('@emotion/styled');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var animationOLXBrandingDotOne = react.keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral__default["default"](["\n    0% {\n        transform: scale(1);\n    }\n    25% {\n        transform: scale(0.5);\n    }\n    50%,\n    100% {\n        transform: scale(1);\n    }\n"])));
var animationOLXBrandingDotTwo = react.keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral__default["default"](["\n    0%,\n    25% {\n        transform: scale(1);\n    }\n    50% {\n        transform: scale(0.5);\n    }\n    75%,\n    100% {\n        transform: scale(1);\n    }\n"])));
var animationOLXBrandingDotThree = react.keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral__default["default"](["\n    0%,\n    50% {\n        transform: scale(1);\n    }\n    75% {\n        transform: scale(0.5);\n    }\n    100% {\n        transform: scale(1);\n    }\n"])));
var SDotsLoader = styled__default["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral__default["default"](["\n    display: inline-flex;\n    position: relative;\n\n    > span {\n        animation: ", "\n            ", " infinite ease-in;\n        display: inline-block;\n    }\n\n    > span,\n    &::before,\n    &::after {\n        border-radius: 50%;\n        border-style: solid;\n        border-width: ", "px;\n        ", ";\n        box-sizing: border-box;\n        content: '';\n        display: inline-block;\n        height: ", "px;\n        width: ", "px;\n    }\n\n    &::before {\n        animation: ", "\n            ", " infinite ease-in;\n        border-width: ", "px;\n        margin-right: ", "px;\n    }\n\n    &::after {\n        animation: ", "\n            ", " infinite ease-in;\n        border-width: ", "px;\n        margin-left: ", "px;\n    }\n"])), animationOLXBrandingDotTwo, function (_ref) {
  var animationDuration = _ref.animationDuration;
  return animationDuration + 's';
}, function (_ref2) {
  var size = _ref2.size;
  return size * 0.38;
}, styledSystem.borderColor, function (_ref3) {
  var size = _ref3.size;
  return size;
}, function (_ref4) {
  var size = _ref4.size;
  return size;
}, animationOLXBrandingDotOne, function (_ref5) {
  var animationDuration = _ref5.animationDuration;
  return animationDuration + 's';
}, function (_ref6) {
  var size = _ref6.size;
  return size * 0.16;
}, function (_ref7) {
  var size = _ref7.size;
  return size * 0.25;
}, animationOLXBrandingDotThree, function (_ref8) {
  var animationDuration = _ref8.animationDuration;
  return animationDuration + 's';
}, function (_ref9) {
  var size = _ref9.size;
  return size * 0.3;
}, function (_ref10) {
  var size = _ref10.size;
  return size * 0.25;
});

exports.SDotsLoader = SDotsLoader;
//# sourceMappingURL=DotsLoader.style.js.map
